import Vue from 'vue';
import { IconDefinition, library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowDown,
  faBars,
  faCheck,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faChevronUp,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faHome,
  faInfoCircle,
  faMinusSquare,
  faPhoneAlt,
  faTimes
} from '@fortawesome/free-solid-svg-icons';
import {
  faBell,
  faFolderOpen,
  faArrowAltCircleRight,
  faCheckCircle,
  faEnvelope,
  faFileAlt
} from '@fortawesome/free-regular-svg-icons';
import { faIdeal } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
  faArrowAltCircleRight,
  faArrowDown,
  faBars,
  faBell,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronRight,
  faChevronLeft,
  faChevronUp,
  faEnvelope,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faFileAlt,
  faFolderOpen,
  faHome,
  faIdeal as IconDefinition,
  faInfoCircle,
  faMinusSquare,
  faPhoneAlt,
  faTimes
);

Vue.component('font-awesome-icon', FontAwesomeIcon);
